"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KelvinWet = exports.FahrenheitWet = exports.CelsiusWet = void 0;
var uom_1 = require("uom");
exports.CelsiusWet = uom_1.Unit.createBase("CelsiusWet", "WetTemperature", "wb°C");
exports.FahrenheitWet = uom_1.Unit.minus("FahrenheitWet", 32.0, uom_1.Unit.timesNumber("", 5.0 / 9.0, exports.CelsiusWet));
exports.KelvinWet = uom_1.Unit.minus("KelvinWet", 273.15, exports.CelsiusWet);
//# sourceMappingURL=wet-temperature.js.map